var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Setup"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Setup",
    clipPath: "url(#clip-Setup)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting",
    transform: "translate(-11.495 -9.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19693",
    "data-name": "Path 19693",
    d: "M19.81,28.829a3.356,3.356,0,0,1-.328-.108,1.4,1.4,0,0,1-.857-1.133c-.047-.286-.094-.576-.145-.861a1.048,1.048,0,0,0-1.4-.833c-.29.1-.581.22-.866.323a1.387,1.387,0,0,1-1.76-.632q-.723-1.243-1.437-2.486a1.383,1.383,0,0,1,.332-1.84c.234-.2.473-.384.7-.581a1.041,1.041,0,0,0,0-1.643c-.239-.206-.487-.4-.73-.6a1.381,1.381,0,0,1-.318-1.788q.723-1.271,1.461-2.533a1.389,1.389,0,0,1,1.737-.618c.286.1.566.215.852.318a1.044,1.044,0,0,0,1.437-.843c.056-.323.1-.646.169-.964a1.373,1.373,0,0,1,1.344-1.114c1,0,2-.009,3,0a1.4,1.4,0,0,1,1.372,1.236c.047.286.094.576.145.861a1.049,1.049,0,0,0,1.4.838c.29-.1.581-.215.871-.323a1.392,1.392,0,0,1,1.765.627q.73,1.25,1.442,2.5a1.388,1.388,0,0,1-.323,1.816c-.234.2-.478.393-.716.59a1.043,1.043,0,0,0,0,1.643c.239.206.487.4.73.6A1.382,1.382,0,0,1,30,23.071q-.723,1.278-1.47,2.547a1.386,1.386,0,0,1-1.713.613c-.29-.1-.576-.22-.866-.323a1.048,1.048,0,0,0-1.442.838c-.051.3-.094.6-.15.9a1.377,1.377,0,0,1-1.114,1.161.242.242,0,0,0-.061.028Q21.488,28.827,19.81,28.829ZM14.2,17.346c.239.2.473.393.707.585a2.451,2.451,0,0,1,0,3.853l-.707.58c.5.857.983,1.7,1.475,2.551.328-.122.632-.239.936-.351a2.446,2.446,0,0,1,3.235,1.868c.061.328.112.655.169.988h2.945c.056-.342.112-.679.173-1.016a2.408,2.408,0,0,1,2.664-1.952,7.838,7.838,0,0,1,1.348.412c.126.042.178.028.243-.089.431-.763.871-1.517,1.311-2.275q.035-.063.07-.14c-.225-.187-.445-.37-.669-.552a2.453,2.453,0,0,1,0-3.909c.225-.183.445-.37.674-.557-.468-.824-.936-1.634-1.4-2.448-.042-.075-.084-.089-.169-.056-.3.117-.609.239-.918.337a2.445,2.445,0,0,1-3.146-1.882c-.061-.332-.117-.665-.173-1H20.016c-.047.281-.1.557-.14.833a2.444,2.444,0,0,1-2.982,2.093,8.294,8.294,0,0,1-1.086-.379c-.1-.037-.154-.023-.206.075-.145.267-.3.524-.454.791Z",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19694",
    "data-name": "Path 19694",
    d: "M127.87,135.647a3.457,3.457,0,1,1,3.572-3.343A3.476,3.476,0,0,1,127.87,135.647Zm2.172-3.46a2.057,2.057,0,1,0-2.065,2.06A2.072,2.072,0,0,0,130.043,132.188Z",
    transform: "translate(-106.492 -112.333)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/Setup.8fa635622aa254f15736e2c5054bd44b.svg";
export { ForwardRef as ReactComponent };